export const PRODUCT_TYPES = ['primo', 'duo', 'ultimo', 'nuovo']
